document.addEventListener('DOMContentLoaded', function () {
      const widget = document.getElementById('yf-location-widget');
      const toggle = document.getElementById('yf-location-toggle');
      const panel = document.getElementById('yf-location-panel');
      const closeBtn = document.getElementById('yf-location-close');
      const applyBtn = document.getElementById('yf-location-apply');
      const clearBtn = document.getElementById('yf-location-clear');
      const summary = document.getElementById('yf-location-summary');
      const reminder = document.getElementById('yf-location-reminder');
      const reminderText = document.getElementById('yf-location-reminder-text');
      const reminderClose = document.getElementById('yf-location-reminder-close');
      const checkboxes = Array.from(document.querySelectorAll('.yf-location-option input[type="checkbox"]'));

      if (!widget || !toggle || !panel || !closeBtn || !applyBtn || !clearBtn || !summary || !checkboxes.length) return;

      const DEFAULT_FILTER_PARAM = 'filter.v.m.locationInventory.locations';
      const STORAGE_KEY = 'yf_inventory_location_filters_session';
      const FACET_MAP_KEY = 'yf_inventory_location_facet_map_v2';
      const REMINDER_DISMISSED_KEY = 'yf_inventory_location_reminder_dismissed_for_url';
      const currentUrl = new URL(window.location.href);
      const isCollectionPage = window.location.pathname.includes('/collections/');
      const isSearchPage = window.location.pathname.includes('/search');
      const isFilterablePage = isCollectionPage || isSearchPage;
      const REGION_VALUES = checkboxes.map(function (checkbox) { return checkbox.value; });

      function classifyRegion(text) {
        const value = String(text || '').toLowerCase().replace(/\s+/g, ' ').trim();
        if (!value) return '';
        if (value.includes('vegreville') || value.includes('alberta') || value.includes('5228 52') || /(^|\W)ab($|\W)/.test(value)) return 'Alberta';
        if (value.includes('prince albert') || value.includes('saskatchewan') || value.includes('saskatoon') || /(^|\W)sk($|\W)/.test(value)) return 'Saskatchewan';
        if (value.includes('online only') || value.includes('online warehouse') || value === 'online') return 'Online Only';
        return '';
      }

      function normalizeRegions(values) {
        const unique = Array.from(new Set((values || []).map(function (value) {
          return REGION_VALUES.includes(value) ? value : classifyRegion(value);
        }).filter(Boolean)));
        return unique.length === REGION_VALUES.length ? [] : unique;
      }

      function getSelectedRegions() {
        return normalizeRegions(checkboxes.filter(function (checkbox) { return checkbox.checked; }).map(function (checkbox) { return checkbox.value; }));
      }

      function setSelectedRegions(values) {
        const normalized = normalizeRegions(values);
        checkboxes.forEach(function (checkbox) { checkbox.checked = normalized.includes(checkbox.value); });
        updateSummary();
      }

      function updateSummary() {
        const values = getSelectedRegions();
        summary.textContent = !values.length ? 'All' : (values.length === 1 ? values[0] : values.length + ' selected');
      }

      function openPanel() {
        widget.setAttribute('data-open', 'true');
        toggle.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
      }
      function closePanel() {
        widget.setAttribute('data-open', 'false');
        toggle.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
      }
      function togglePanel() {
        widget.getAttribute('data-open') === 'true' ? closePanel() : openPanel();
      }
      window.YFLocationFilter = { open: openPanel, close: closePanel, toggle: togglePanel, isOpen: function () { return widget.getAttribute('data-open') === 'true'; } };

      function dedupeFacetOptions(options) {
        const seen = new Set();
        return (options || []).filter(function (option) {
          if (!option || !option.name || !option.value || !option.region) return false;
          const key = option.name + '\u0000' + option.value;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
      }

      function discoverFacetOptions() {
        const options = [];
        document.querySelectorAll('input[type="checkbox"][name^="filter."]').forEach(function (input) {
          const filterRoot = input.closest('[id^="collection-filter-"]');
          const heading = filterRoot && filterRoot.querySelector('summary') ? filterRoot.querySelector('summary').textContent : '';
          const label = input.closest('label') ? input.closest('label').textContent : '';
          const nameLooksRight = /location/i.test(input.name || '');
          const headingLooksRight = /location|inventory/i.test(heading || '');
          if (!nameLooksRight && !headingLooksRight) return;
          const region = classifyRegion([input.value, label, heading].join(' '));
          if (region) options.push({ name: input.name, value: input.value, region: region });
        });

        const clean = dedupeFacetOptions(options);
        if (clean.length) {
          try { sessionStorage.setItem(FACET_MAP_KEY, JSON.stringify(clean)); } catch (error) {}
          return clean;
        }

        try { return dedupeFacetOptions(JSON.parse(sessionStorage.getItem(FACET_MAP_KEY) || '[]')); }
        catch (error) { return []; }
      }

      function locationParamNames(options, url) {
        const names = new Set([DEFAULT_FILTER_PARAM]);
        (options || []).forEach(function (option) { if (option.name) names.add(option.name); });
        Array.from(url.searchParams.keys()).forEach(function (name) {
          if (/^filter\./i.test(name) && /location|inventory/i.test(name)) names.add(name);
        });
        return Array.from(names);
      }

      function removeLocationParams(url, options) {
        locationParamNames(options, url).forEach(function (name) { url.searchParams.delete(name); });
      }

      function regionsFromUrl(url, options) {
        const regions = [];
        locationParamNames(options, url).forEach(function (name) {
          url.searchParams.getAll(name).forEach(function (value) {
            let region = classifyRegion(value);
            if (!region) {
              const match = (options || []).find(function (option) { return option.name === name && option.value === value; });
              region = match ? match.region : '';
            }
            if (region) regions.push(region);
          });
        });
        return normalizeRegions(regions);
      }

      function selectionsForRegions(regions, options) {
        const selected = normalizeRegions(regions);
        const matches = dedupeFacetOptions((options || []).filter(function (option) { return selected.includes(option.region); }));
        if (!matches.length) return [];
        // Shopify uses one parameter name for a given facet. Prefer the parameter
        // that has the most matching values in the rendered filter controls.
        const counts = {};
        matches.forEach(function (option) { counts[option.name] = (counts[option.name] || 0) + 1; });
        const bestName = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; })[0];
        return matches.filter(function (option) { return option.name === bestName; });
      }

      function saveRegions(regions) {
        const normalized = normalizeRegions(regions);
        try {
          if (normalized.length) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
          else sessionStorage.removeItem(STORAGE_KEY);
        } catch (error) {}
      }

      function readStoredRegions() {
        try { return normalizeRegions(JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]')); }
        catch (error) { return []; }
      }

      function applyFilters(regions, replace) {
        const normalized = normalizeRegions(regions);
        const options = discoverFacetOptions();
        const targetUrl = isFilterablePage ? new URL(window.location.href) : new URL('/collections/all', window.location.origin);
        removeLocationParams(targetUrl, options);
        targetUrl.searchParams.delete('page');
        saveRegions(normalized);

        if (normalized.length) {
          const selections = selectionsForRegions(normalized, options);
          if (!selections.length) {
            // On pages without product facets (home/product/content pages), move to
            // All Products first. That page can discover Shopify's exact location
            // facet values and safely apply the saved region on the next render.
            if (!isFilterablePage) {
              window.location.href = targetUrl.toString();
              return;
            }

            // Never guess a metafield filter value. A guessed value was the cause
            // of valid search results flashing briefly and then becoming zero.
            setSelectedRegions(normalized);
            closePanel();
            if (reminder && reminderText) {
              reminderText.textContent = 'Location filtering is not available for this result set. Showing all matching products.';
              reminder.hidden = false;
            }
            return;
          }
          selections.forEach(function (selection) { targetUrl.searchParams.append(selection.name, selection.value); });
        }

        if (replace) window.location.replace(targetUrl.toString());
        else window.location.href = targetUrl.toString();
      }

      function visibleProductCount() {
        const cards = document.querySelectorAll('collection-products [data-yf-collection-product-card]');
        if (cards.length) return cards.length;
        const status = document.querySelector('[data-product-count], .collection-product-count, .\\#collection-toolbar-status');
        const match = status && String(status.textContent || '').replace(/,/g, '').match(/(\d+)\s*(?:products?|results?)/i);
        return match ? Number(match[1]) : null;
      }

      function showReminderIfNeeded(regions) {
        if (!reminder || !reminderText) return;
        const normalized = normalizeRegions(regions);
        if (!isFilterablePage || !normalized.length) { reminder.hidden = true; return; }
        const reminderKey = window.location.pathname + window.location.search;
        try { if (sessionStorage.getItem(REMINDER_DISMISSED_KEY) === reminderKey) { reminder.hidden = true; return; } } catch (error) {}
        const count = visibleProductCount();
        if (count === 0) reminderText.textContent = 'No products matched this location. Clear the location filter to see all matching products.';
        else if (normalized.length === 1) reminderText.textContent = 'Showing only ' + normalized[0] + ' inventory.';
        else reminderText.textContent = 'Showing only the selected locations.';
        reminder.hidden = false;
      }

      const facetOptions = discoverFacetOptions();
      const activeLocationPairs = [];
      locationParamNames(facetOptions, currentUrl).forEach(function (name) {
        currentUrl.searchParams.getAll(name).forEach(function (value) {
          activeLocationPairs.push({ name: name, value: value });
        });
      });
      const urlLocationValues = activeLocationPairs.length > 0;
      const urlRegions = regionsFromUrl(currentUrl, facetOptions);
      const storedRegions = readStoredRegions();
      const urlPairsAreKnown = activeLocationPairs.every(function (pair) {
        return facetOptions.some(function (option) {
          return option.name === pair.name && option.value === pair.value;
        });
      });
      const urlUsesFriendlyGuess = activeLocationPairs.some(function (pair) {
        return REGION_VALUES.includes(pair.value);
      });

      if (urlLocationValues) {
        if (urlRegions.length && facetOptions.length && !urlPairsAreKnown) {
          const correctedSelections = selectionsForRegions(urlRegions, facetOptions);
          if (correctedSelections.length) {
            const correctedUrl = new URL(window.location.href);
            removeLocationParams(correctedUrl, facetOptions);
            correctedSelections.forEach(function (selection) {
              correctedUrl.searchParams.append(selection.name, selection.value);
            });
            correctedUrl.searchParams.delete('page');
            saveRegions(urlRegions);
            window.location.replace(correctedUrl.toString());
            return;
          }
        }

        if (urlRegions.length && (!urlUsesFriendlyGuess || urlPairsAreKnown)) {
          setSelectedRegions(urlRegions);
          saveRegions(urlRegions);
        } else {
          // Recover from URLs produced by the previous theme version. Remove the
          // invalid guessed filter first; the next unfiltered render can discover
          // Shopify's exact facet values and safely reapply the saved region.
          const cleanUrl = new URL(window.location.href);
          removeLocationParams(cleanUrl, facetOptions);
          cleanUrl.searchParams.delete('page');
          window.location.replace(cleanUrl.toString());
          return;
        }
      } else if (storedRegions.length) {
        setSelectedRegions(storedRegions);
        const selections = selectionsForRegions(storedRegions, facetOptions);
        if (isFilterablePage && selections.length) {
          const filteredUrl = new URL(window.location.href);
          removeLocationParams(filteredUrl, facetOptions);
          selections.forEach(function (selection) { filteredUrl.searchParams.append(selection.name, selection.value); });
          filteredUrl.searchParams.delete('page');
          window.location.replace(filteredUrl.toString());
          return;
        }
      } else {
        updateSummary();
      }

      toggle.addEventListener('click', togglePanel);
      closeBtn.addEventListener('click', closePanel);
      applyBtn.addEventListener('click', function () { applyFilters(getSelectedRegions(), false); });
      clearBtn.addEventListener('click', function () { setSelectedRegions([]); applyFilters([], false); });
      if (reminderClose) reminderClose.addEventListener('click', function () {
        try { sessionStorage.setItem(REMINDER_DISMISSED_KEY, window.location.pathname + window.location.search); } catch (error) {}
        reminder.hidden = true;
      });
      checkboxes.forEach(function (checkbox) { checkbox.addEventListener('change', updateSummary); });
      document.addEventListener('click', function (event) {
        if (event.target.closest && event.target.closest('[data-yf-mobile-location-button]')) return;
        if (!widget.contains(event.target)) closePanel();
      });
      document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closePanel(); });
      window.addEventListener('load', function () {
        setTimeout(function () { showReminderIfNeeded(urlRegions.length ? urlRegions : storedRegions); }, 700);
      });
    });
